
import { useState, useEffect, useRef } from 'react';
import { TransformWrapper, TransformComponent } from "@pronestor/react-zoom-pan-pinch";
import { useResizeDetector } from 'react-resize-detector';
import { InView } from 'react-intersection-observer';
import styled, { css } from "styled-components/macro";

import mobileMap from "../images/mobileMap.png";
import mobileMapBlue from "../images/mobileMap-blue.png";
import mobileMapBase from "../images/mobileMap-base.png";

import desktopMap from "../images/desktopMap.png";
import desktopMapBlue from "../images/desktopMap-blue.png";
import desktopMapBase from "../images/desktopMap-base.png";
import desktopMapExtension from "../images/desktopMap-extension.png";
import desktopMapBlueExtension from "../images/desktopMapBlue-extension.png";

import desktopLargeMap from "../images/desktopMapLarge.png";
import desktopLargeMapBlue from "../images/desktopMapLarge-blue.png";
import desktopLargeMapBase from "../images/desktopMapLarge-base.png";

import Pin from "../components/Pin";
import Sidebar from './Sidebar'
import Icon from "../components/Icon";


import map1_mobile from "../images/map1-mobile.png";
import map1_desktop from "../images/map1-desktop.png";
import map1_desktopLarge from "../images/map1-desktopLarge.png";

import map2_mobile from "../images/map2-mobile.png";
import map2_desktop from "../images/map2-desktop.png";
import map2_desktopLarge from "../images/map2-desktopLarge.png"; 

import map3_mobile from "../images/map3-mobile.png";
import map3_desktop from "../images/map3-desktop.png";
import map3_desktopLarge from "../images/map3-desktopLarge.png"; 

import map4_mobile from "../images/map4-mobile.png";
import map4_desktop from "../images/map4-desktop.png";
import map4_desktopLarge from "../images/map4-desktopLarge.png"; 

import map5_mobile from "../images/map5-mobile.png";
import map5_desktop from "../images/map5-desktop.png";
import map5_desktopLarge from "../images/map5-desktopLarge.png"; 

import map6_mobile from "../images/map6-mobile.png";
import map6_desktop from "../images/map6-desktop.png";
import map6_desktopLarge from "../images/map6-desktopLarge.png"; 

import map7_mobile from "../images/map7-mobile.png";
import map7_desktop from "../images/map7-desktop.png";
import map7_desktopLarge from "../images/map7-desktopLarge.png"; 

import map8_mobile from "../images/map8-mobile.png";
import map8_desktop from "../images/map8-desktop.png";
import map8_desktopLarge from "../images/map8-desktopLarge.png"; 

import map9_mobile from "../images/map9-mobile.png";
import map9_desktop from "../images/map9-desktop.png";
import map9_desktopLarge from "../images/map9-desktopLarge.png"; 

import map10_mobile from "../images/map10-mobile.png";
import map10_desktop from "../images/map10-desktop.png";
import map10_desktopLarge from "../images/map10-desktopLarge.png"; 

import map11_mobile from "../images/map11-mobile.png";
import map11_desktop from "../images/map11-desktop.png";
import map11_desktopLarge from "../images/map11-desktopLarge.png"; 

import map12_mobile from "../images/map12-mobile.png";
import map12_desktop from "../images/map12-desktop.png";
import map12_desktopLarge from "../images/map12-desktopLarge.png"; 

const mapLibrary = [
    { 
        'map' : 1,
        'desktopLarge' : map1_desktopLarge,
        'desktop' : map1_desktop,
        'mobile' : map1_mobile
    },
    { 
        'map' : 2,
        'desktopLarge' : map2_desktopLarge,
        'desktop' : map2_desktop,
        'mobile' : map2_mobile
    },
    { 
        'map' : 3,
        'desktopLarge' : map3_desktopLarge,
        'desktop' : map3_desktop,
        'mobile' : map3_mobile
    },
    { 
        'map' : 4,
        'desktopLarge' : map4_desktopLarge,
        'desktop' : map4_desktop,
        'mobile' : map4_mobile
    },
    { 
        'map' : 5,
        'desktopLarge' : map5_desktopLarge,
        'desktop' : map5_desktop,
        'mobile' : map5_mobile
    },
    { 
        'map' : 6,
        'desktopLarge' : map6_desktopLarge,
        'desktop' : map6_desktop,
        'mobile' : map6_mobile
    },
    { 
        'map' : 7,
        'desktopLarge' : map7_desktopLarge,
        'desktop' : map7_desktop,
        'mobile' : map7_mobile
    },
    { 
        'map' : 8,
        'desktopLarge' : map8_desktopLarge,
        'desktop' : map8_desktop,
        'mobile' : map8_mobile
    },
    { 
        'map' : 9,
        'desktopLarge' : map9_desktopLarge,
        'desktop' : map9_desktop,
        'mobile' : map9_mobile
    },
    { 
        'map' : 10,
        'desktopLarge' : map10_desktopLarge,
        'desktop' : map10_desktop,
        'mobile' : map10_mobile
    },
    { 
        'map' : 11,
        'desktopLarge' : map11_desktopLarge,
        'desktop' : map11_desktop,
        'mobile' : map11_mobile
    },
    { 
        'map' : 12,
        'desktopLarge' : map12_desktopLarge,
        'desktop' : map12_desktop,
        'mobile' : map12_mobile
    }
]


/* 
    ## NOTES ##

    When changing the map, change the map pseudo as well (a blank image of identical dimensions)

    Pin Zoom and Move
    - The zoom and offsets must be carefully tweaked together or they'll ruin a smooth transition. 
    - If you use offset, you must use zoom, and enough to stop any map edges from becoming evident

*/



const Wrapper = styled.div`
    position:relative;
    width: 100%;
    ${props => !props.isDesktop && css`
        height:100vh;
        border-bottom:1px solid #CAD2DD;
    `}

    .react-transform-wrapper {
        //by default sets to the size of the content... map size at scale(1)
        //must add 100% max width, so the content then extends past the element, and it doesn't exceed page width
        max-width:100%;
        //the issue is the height. I'm not limiting it to 100vh and it is set by default to the FULL map height
        //so, after scaling down the map based on width, I then get that map height and update the container
        max-height:100%; 
        overflow: hidden;
        cursor: grab;
        background: #0C3E8D;
    }

    .InView {
        pointer-events: none;
        touch-action: none;
    }
`

const DesktopWrapper = styled.div`
    position:relative;
    width:100%;
    overflow:hidden;
    background: #0C3E8D;
    img {
        width:100%;
    }
    display:flex;
    flex-wrap:nowrap;
    align-items:stretch;
`

const Stage = styled.div.attrs(props => ({
    style: {
        transform: `${props.stageZoom ? 'scale(' + props.stageZoom.zoom + ')' : 'none'}`,
        left: `${props.stageZoom ? props.stageZoom.offsetX + '%' : 'none'}`,
        top: `${props.stageZoom ? props.stageZoom.offsetY + 'px' : 'none'}`,
      
    },
    }))`
    transition: transform .2s ease-out;
    //holds the map size so when maps flip the sizing doesn't flash     
    width:100%;
    position:relative;
    background-color:#0C3E8D;
    > img {
        top:3px; //fixes a visual bug where map does not reach bottom of container
        right:1px;
    }
`

const MapPseudo = styled.img`
    /* MapPseudo is an empty image at the exact same dimensions as the real maps. Used to maintain wrapper dimensions when maps are switching */
    width:100%;
    opacity:0;
`

const MapBaseBlue = styled.img`
    position:absolute;
    width:100%;
    left:0;
    top:0;
    height:auto;
    z-index:0;
`

const MapBaseDefault = styled.img`
    position:absolute;
    width:100%;
    left:0;
    top:0;
    height:auto;
    z-index:1;
    transition: opacity .2s ease-in;
    ${ props => props.activePinNumber && css`
        opacity:0;
    `}
`

const ActiveMap = styled.img`
    position:absolute;
    left:0;
    top:0;
    width:100%;
    height:auto;
    z-index:2;
`

const MapExtensionBlue = styled.img`
    opacity: ${props => props.activePinNumber ? '1' : '0'}
    
`

const MapExtensionDefault = styled.img`
    ${ props => props.activePinNumber && css`
        opacity:0;
    `}
`

const MapExtension = styled.div`
   //do NOT give this position relative, the child img height is based off its grandparent
   //height:100%;
   flex-shrink: 0;
   background-color:#073577;
    img {
        width:300px;
        position:absolute;
        height:100%;
        top:0;
        right:0;
    }
    //Handle width
    width:0;
    img { 
        width:0;
    }
    @media(max-width:1650px){
        width:250px; //If you change this, change the Pin desktop code for pinPosY
        img { 
            width:250px;
        }
    }
`

const PinUXPromptWrapper = styled.div`
    position:absolute;
    top:0;
    max-width: 1800px;
    width: 100%;
    margin: 0 auto;
    padding: 0 3rem;
    left: 0;
    right: 0;
    @media(max-width: 1799px){
        padding: 0 10rem;
    }
    @media(max-width: 1000px){
        padding: 0 3rem;
    }
`

const PinUXPrompt = styled.div`
    font-family:'GT America', sans-serif;;
    font-size: 2.4rem;
    font-weight:700;
    color: #fff;
    z-index: 1;
    position: relative;
    top:-2rem;
    @media(max-width: 1000px){
        text-align:center;
        top:-5rem;
    }
    
`

const MobileUXPrompt = styled.div`
    position:absolute;
    top:50%;
    transform:translateY(-50%);
    width:100%; 
    padding:20px;
    display:flex;
    justify-content:center;
    align-items:center;

    ${ props => props.isDesktop && css`
        display:none;
    `}

    ${ props => props.activePinNumber && css`
        display:none;
    `}

    ${ props => !props.disablePanning && css`
        width: fit-content;
        right: 0;
    `}

`

const MobileUXContent = styled.div`
    display:flex;
    align-items:center;
    background-color:rgba(255,255,255,0.9);
    padding:30px 20px;
    border-radius:10px;
    svg {
        width:18px;
        height:100%;
        path {
            fill:#F79A37;
        }
    }    
    &:hover {
        cursor:pointer;
    }
    transition: all .2s ease-out;
    ${ props => !props.disablePanning && css`
        padding: 10px 15px;
        > svg {
           display:none;
        }
    `}
`

const MobileText = styled.div`

    font-size:17px;
    font-weight:700;
    color:#0C3E8D;
    margin: 0 14px;

    ${ props => !props.disablePanning && css`
        opacity:0;
        width:0;
        height:0;
        overflow:hiddden;
        margin:0;
        padding:0;
        display:none; 
    `}
`

const MobileUXLock = styled.div`
    ${ props => props.disablePanning && css`
        display:none;
    `}
`

// ------------------------------------------------- */

export default function MapContainer(props){
    
    const [ browserWidth, setBrowserWidth ] = useState(null);
    const [ browserHeight, setBrowserHeight ] = useState(null);
    const [ isDesktop, setIsDesktop ] = useState(null);
    const [ activePinNumber, setActivePinNumber ] = useState(null);
    const [ stageZoom, setStageZoom ] = useState({zoom:1, offsetX:0, offsetY:0});

    const [ showMobileUXPrompt, setShowMobileUXPrompt ] = useState(true);
    const [ disablePanning, setDisablePanning ] = useState(true);
    const [ showPinUXPrompt, setShowPinUXPrompt ] = useState(true);

    //Animation States
    const [ animatePinOut, setAnimatePinOut ] = useState(false)

    const transformRef = useRef(null);
    const { width, height, ref } = useResizeDetector();
    const desktopMapRef = useRef(null);

    const desktopLargeBreakpoint = 1650; 
    const mobileBreakpoint = 1024; //media queries should use isDesktop as a prop and not hardcode in 1024 
    const mapWidth = 4000;
    const mapHeight = 3000;
    
    //Runs once on page load
    useEffect(() => {
        setIsDesktop(window.innerWidth > mobileBreakpoint)
        setBrowserHeight(window.innerHeight)
        document.body.classList.add('body--interactive');
    }, []);

    //Watches the browser window resize  
    if (width !== browserWidth){
        if (isDesktop && width <= mobileBreakpoint && activePinNumber){
            //when switching from desktop to mobile with blue map open, scale gets all messed up. Just reset the pin. 
            setActivePinNumber(null)
        }
        setBrowserWidth(width)
        setIsDesktop(width > mobileBreakpoint)
    }

    let KI_mobileMenu = document.querySelector('.header');

     //Watches the browser window resize  
     if (height !== browserHeight){
        if (KI_mobileMenu){
            if (!KI_mobileMenu.classList.contains("mobile-menu-is-open")){
                // console.log("height changed")
                setBrowserHeight(height)
            }
        } else {
            setBrowserHeight(height)
        }
    }

    // Decide when to call handleMapZoom  
    useEffect(() => {
        //the mobile menu really screws with it, so only when it's closed
        if (KI_mobileMenu){
            if (!KI_mobileMenu.classList.contains("mobile-menu-is-open")){
                // console.log("ki mobile menu exists and zoom")
                handleMapZoom()
            }
        } else {
            // console.log("ki no header")
            handleMapZoom()
        }
       
    }, [browserWidth, browserHeight, activePinNumber])

    // ------------------------------------------------- */


    function handleMapZoom(){

        // console.log("ki zoom")
        /* 
        This function is ONLY called by a single UseEffect observing three states. Triggered during... 
        - initial load (for mobile)
        - resizing browser (to / from mobile)
        - opening / closing a pin 
        */

        //limit this running for performance as much as possible
        //Desktop and Mobile handle differently

        //First get active pin info
        let zoomObj = null;
        if (activePinNumber && props.airtablePins.length > 0){
            let activePinInfo = props.airtablePins.filter(pinData => pinData.fields['Pin Type'] === 'Pin' && pinData.fields['Pin Number'] === activePinNumber)
            if (activePinInfo.length > 0){
                activePinInfo = activePinInfo[0].fields;
                if (isDesktop){
                    zoomObj = {
                        amount : activePinInfo['Zoom Amount'],
                        offsetX : activePinInfo['Zoom X Offset'],
                        offsetY : activePinInfo['Zoom Y Offset']
                    }
                } else {
                    zoomObj = {
                        amount_LG : activePinInfo['Mobile LG Zoom'],
                        amount_SM : activePinInfo['Mobile SM Zoom'],
                        offsetX_LG : activePinInfo['Mobile LG X'],
                        offsetX_SM : activePinInfo['Mobile SM X'],
                        offsetY_LG : activePinInfo['Mobile LG Y'],
                        offsetY_SM : activePinInfo['Mobile SM Y'],
                        offsetY : activePinInfo['Mobile Zoom Y Offset']
                    }
                }
               
            } else {
                console.warn("Could not find Pin")
            }
        }

        if (isDesktop){
            if (activePinNumber && zoomObj){
                //top only works as px, not %, so convert it 
                let offsetYPX = zoomObj.offsetY; 
                if (desktopMapRef.current){
                    offsetYPX = (desktopMapRef.current.clientHeight * (zoomObj.offsetY / 100)) * -1; 
                }
                setStageZoom({zoom:zoomObj.amount, offsetX:zoomObj.offsetX, offsetY:offsetYPX})
            } 
            else {
                setStageZoom({zoom:1, offsetX:0, offsetY:0})
            }
        } 
        else {
            if (!transformRef.current){
                console.warn("Cannot find Transform Reference")
                return;
            }

            const { setTransform, centerView } = transformRef.current;

            let mobileHeight = activePinNumber ? 50 : 100; //in VH 
            document.querySelector(".react-transform-wrapper").setAttribute("style",`height:${mobileHeight}vh`);

            if (activePinNumber){
              
                //This could be improved with a browserHeight
                let widthRatio = 1020 / browserWidth;

                let offsetX = 1;
                let offsetY = 1;

                if (browserWidth > 600){
                    zoomObj.amount = zoomObj.amount_LG;
                    offsetX = zoomObj.offsetX_LG * widthRatio;
                    offsetY = zoomObj.offsetY_LG;
                } else {
                    zoomObj.amount = zoomObj.amount_SM;
                    offsetX = zoomObj.offsetX_SM * widthRatio;
                    offsetY = zoomObj.offsetY_SM;
                }

                // if (activePinNumber === 12){
                //     if (browserWidth > 600){
                //         zoomObj.amount = 0.23;
                //         offsetX = 150 * widthRatio;
                //         offsetY = 100;
                //     } else {
                //         zoomObj.amount = 0.18;
                //         offsetX = 120 * widthRatio;
                //         offsetY = 80; 
                //     }
                // }
                
                setTransform(-offsetX, -offsetY, zoomObj.amount)
            }
            else {
                //Default scale, figured by height of map is height of browser
                let newScale = (browserHeight / mapHeight) 
                setTransform(0, 0, newScale)
            }             
        }
    }


    function handlePinChange(number){
        setShowPinUXPrompt(false)
        if (number){
            setDisablePanning(false)
        } 
        setActivePinNumber(number)
    }

    // function handleMobileUXPrompt(inView, mobile){
    //     if (!isDesktop){
    //         //For now, only on delay. Uncomment line below for on touch hiding
    //         if (inView && mobile && showMobileUXPrompt){
    //             // setShowMobileUXPrompt(false);
    //         }
    //         else if (inView && showMobileUXPrompt){
    //             setTimeout(()=>{
    //                 setShowMobileUXPrompt(false);
    //             }, 2500)
    //         }
    //     }
    // }

    function handleUXPrompt(event, source){
        if (source === 'touch'){
            event.preventDefault()
            setDisablePanning(!disablePanning)
        } 
        else {
            setDisablePanning(!disablePanning)
        }
    
    }

    /*--- FUNCTIONAL COMPONENTS -----*/ 

    function ShowActiveMap(){

        if (activePinNumber){

            let mapSize = 'desktop';

            if (browserWidth >= desktopLargeBreakpoint){
                mapSize = 'desktopLarge';
            }
            else if (browserWidth < desktopLargeBreakpoint && browserWidth > mobileBreakpoint){
                mapSize = 'desktop';
            } 
            else {
                mapSize = 'mobile';
            }

            let mapSelection = mapLibrary.filter( x => x.map === activePinNumber)[0]

            if (mapSelection){
                return <ActiveMap src={mapSelection[mapSize]} alt="Overlay of relevant energy solution flows" />
            }

        }
    }

    function Pins(attr){

        return props.airtablePins.map((pinData, key) => {
      
            let data = pinData.fields;
            //If Pin is referencing another, bring over relevant fields
            if (data['Pin Type'] === 'Reference'){
                let newData = []
                if (data['Reference Pin'] && data['Reference Pin'][0]){
                    let referencedData = props.airtablePins.filter( pin => pin.id === data['Reference Pin'][0]);    
                    if (referencedData[0] && referencedData[0].fields){
                        for (const [key, value] of Object.entries(referencedData[0].fields)) {
                            if (key === 'Pin X Position' || key === 'Pin Y Position' || key === 'Id'){
                                newData[key] = data[key]
                            } else {
                                newData[key] = value
                            }
                        }
                    } 
                } else {
                    console.warn("Couldn't find referenced pin ID ", data['Reference Pin'])
                }
                data = newData;
            }

            let animationDelay = 0.2 + key * 0.1;

            let pinPosY = data['Pin Y Position'];
            let pinPosX = data['Pin X Position'];

            if (browserWidth >= desktopLargeBreakpoint){
                pinPosX = pinPosX * 0.928;  //0.928 calculated by (default map width / large map width)
            }

            if (browserWidth < desktopLargeBreakpoint && browserWidth > mobileBreakpoint ){
              
                let originalHeight = (width - 250) / 1.71166; //original map width - sidebar extension / height ratio
                let yPosInPX = originalHeight * (pinPosY / 100) //px from top if using original sized map
                let extensionInPX = originalHeight * 0.16667; //ratio of extension height to the original height 
                let newYPos = ((yPosInPX + extensionInPX) / height) * 100; 

                pinPosY = newYPos;
            }

                return(
                    <Pin 
                        id={pinData['id']}
                        number={data['Pin Number']}
                        key={key} 
                        posX={pinPosX} 
                        posY={pinPosY} 
                        description={data['Description']}
                        block1Icon={data['Block 1 Icon']}
                        block1Title={data['Block 1 Title']}
                        block1Description={data['Block 1 Description']}
                        block2Icon={data['Block 2 Icon']}
                        block2Title={data['Block 2 Title']}
                        block2Description={data['Block 2 Description']}
                        block3Icon={data['Block 3 Icon']}
                        block3Title={data['Block 3 Title']}
                        block3Description={data['Block 3 Description']}
                        active={activePinNumber === data['Content ID']}
                        activePinNumber={activePinNumber}
                        scaleBase={attr.scale}
                        setActivePinNumber={handlePinChange}
                        animDelay={animationDelay}
                        animatePinOut={animatePinOut}
                        isDesktop={isDesktop}
                        // modalSlideOut={modalSlideOut}
                    />
                )                   
        })
    }



    /*--- RENDER -----*/ 

    return(
        <Wrapper ref={ref} isDesktop={isDesktop}>

        { showPinUXPrompt && isDesktop || !isDesktop ?
            <PinUXPromptWrapper>
                <PinUXPrompt>
                    Click an item to start exploring.
                </PinUXPrompt>
            </PinUXPromptWrapper> 
            : null 
        }
     

        { isDesktop !== null ?
            
            <>

            { isDesktop ?
                <DesktopWrapper ref={desktopMapRef}>
        
                    <Stage stageZoom={stageZoom} >
                        { browserWidth >= desktopLargeBreakpoint ?
                            <>
                                <MapPseudo src={desktopLargeMapBase} alt="" aria-hidden="true" />
                                <MapBaseBlue src={ desktopLargeMapBlue } activePinNumber={ activePinNumber } alt="Blueprint of City with Energy Infrastructure buildings" />
                                <MapBaseDefault src={ desktopLargeMap } activePinNumber={ activePinNumber } alt="Map of City with Energy Infrastructure buildings" />
                            </>
                        :
                            <>
                                <MapPseudo src={desktopMapBase} alt="" />
                                <MapBaseBlue src={ desktopMapBlue } activePinNumber={ activePinNumber } alt="Blueprint of City with Energy Infrastructure buildings" />
                                <MapBaseDefault src={ desktopMap } activePinNumber={ activePinNumber } alt="Map of City with Energy Infrastructure buildings" />
                            </>
                        }
                        
                        <ShowActiveMap />
                        <Pins scale={1} />
                    </Stage>
                    <MapExtension>
                        <MapExtensionDefault src={ desktopMapExtension } activePinNumber={ activePinNumber } alt="" aria-hidden="true" /> 
                        <MapExtensionBlue src={ desktopMapBlueExtension } activePinNumber={ activePinNumber } alt="" aria-hidden="true" /> 
                    </MapExtension>
                   
                </DesktopWrapper>
            :
                <TransformWrapper 
                    initialScale={1}
                    centerOnInit={true}
                    ref={transformRef}
                    limitToBounds={true}
                    wheel={{disabled:true}}
                    pinch={{disabled:true}}
                    doubleClick={{disabled:true}}
                    panning={{disabled:disablePanning}}
                    // minScale={0.1}
                    // maxScale={1}
                    // panning={{lockAxisX:true}}
                    // pan = {{paddingSize: 0}}
                    className="transformWrapper"
                >
                    {({ state: { scale } }) => (
                        <>
                            <TransformComponent>
                                <img src={ activePinNumber ? mobileMapBlue : mobileMap } alt="Map of City with Energy Infrastructure buildings" />
                                {/* <MapPseudo src={mobileMapBase} /> */}
                                <ShowActiveMap />
                                
                                { !activePinNumber 
                                 ?  <Pins scale={scale} />
                                 : null }
                             
                            </TransformComponent>
                        </>
                        )}
                </TransformWrapper>
            }
       
        <Sidebar 
            airtablePins={props.airtablePins}
            activePinNumber={activePinNumber} 
            setActivePinNumber={handlePinChange} 
            isDesktop={isDesktop}
            />
        
        {/* <InView as="div" onChange={(inView, entry) => handleMobileUXPrompt(inView)} className="InView"> */}
            <MobileUXPrompt 
                isDesktop={isDesktop} 
                showMobileUXPrompt={showMobileUXPrompt} 
                activePinNumber={activePinNumber} 
                disablePanning={disablePanning}
                // onTouchStart={handleUXPrompt}
                // onClick={handleUXPrompt}
                onMouseUp={(event) => handleUXPrompt(event, "mouse")}
                onTouchEnd={(event) => handleUXPrompt(event, "touch")}
                >
                <MobileUXContent disablePanning={disablePanning}>
                    <Icon type="Arrow Left" />
                    <MobileText disablePanning={disablePanning}>Tap to unlock map panning</MobileText>
                    <MobileUXLock disablePanning={disablePanning}>
                        <svg width="20" height="28" viewBox="0 0 20 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path fillRule="evenodd" clipRule="evenodd" d="M1.7857 8.47371C1.7857 3.79382 5.46332 0 9.99995 0C14.5366 0 18.2143 3.79382 18.2143 8.47371V12.8947H18.75C19.4403 12.8947 20 13.4721 20 14.1842V25.0526C20 26.6804 18.7208 28 17.1428 28H2.85716C1.27916 28 0 26.6804 0 25.0526V14.1842C0 13.4721 0.559599 12.8947 1.25002 12.8947H1.7857V8.47371ZM3.92852 12.8947H16.0714V8.47371C16.0714 5.01459 13.3532 2.21055 9.99995 2.21055C6.64682 2.21055 3.92852 5.01459 3.92852 8.47371V12.8947ZM2.14282 15.1053V25.0526C2.14282 25.4596 2.46266 25.7895 2.85716 25.7895H17.1428C17.5373 25.7895 17.8571 25.4596 17.8571 25.0526V15.1053H2.14282Z" fill="#F79A37"/>
                        </svg>
                    </MobileUXLock>
                    <Icon type="Arrow Right" />
                </MobileUXContent>
            </MobileUXPrompt>
        {/* </InView> */}

        

        </>
            
        : null }

        </Wrapper>
    )
}